import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { AgreementsAutocomplete, CategoriesAutocomplete, Form } from "@shared/components";

export const CompanyListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/company_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <CategoriesAutocomplete
          name="field_of_activity"
          label={translate("v1/company_admin.fields.field_of_activity")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("v1/company_admin.fields.agreement")}
        />
      </Grid>
    </Grid>
  );
});
